var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37207 1.5H9.57682C12.0218 1.5 13.2458 1.5 14.0948 2.0985C14.3378 2.2695 14.5538 2.4735 14.7361 2.70225C15.3721 3.50175 15.3721 4.65225 15.3721 6.95475V8.8635C15.3721 11.0857 15.3721 12.1972 15.0203 13.0845C14.4548 14.5117 13.2593 15.6368 11.7428 16.1693C10.8001 16.5 9.62032 16.5 7.25782 16.5C5.90932 16.5 5.23432 16.5 4.69582 16.311C3.82957 16.0065 3.14632 15.3638 2.82307 14.5485C2.62207 14.0415 2.62207 13.4062 2.62207 12.1365V9",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3735 9C15.3735 9.66297 15.1102 10.2988 14.6414 10.7676C14.1726 11.2364 13.5368 11.4998 12.8738 11.4998C12.3743 11.4998 11.7855 11.4128 11.3003 11.5425C11.0883 11.5995 10.8951 11.7112 10.7399 11.8664C10.5847 12.0216 10.473 12.2148 10.416 12.4268C10.2863 12.912 10.3733 13.5007 10.3733 14.0002C10.3733 14.3285 10.3086 14.6536 10.183 14.9569C10.0574 15.2601 9.87325 15.5357 9.64113 15.7678C9.409 16 9.13343 16.1841 8.83015 16.3097C8.52686 16.4353 8.20181 16.5 7.87354 16.5M3.37354 3.375C3.74254 2.9955 4.72354 1.5 5.24854 1.5M5.24854 1.5C5.77354 1.5 6.75454 2.9955 7.12354 3.375M5.24854 1.5V7.5",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsFileUpload);
export default __webpack_public_path__ + "static/media/hugeicons_file-upload.2559a453d6a907f36a26ac2e690036ba.svg";
export { ForwardRef as ReactComponent };